
import React from "react";

export function TotalProductFormatter(cellContent,row){

    return(
        <>
            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                {row.totalProductQty}
            </span>
        </>
    )
}